module.exports = __webpack_public_path__ + "img/1958-3.0ca18e78.png";